import request from "@/services/request";
import axios from "axios";

export default {
  state: {
    toggleNumberBlocks: {},
    toggleNumberBlocksLoaded: false
    // toggleNumberBlocks: [
    //   {
    //     title: "Бакалавриат / специалитет",
    //     path: "/bakalavriat",
    //     items: [
    //       {
    //         id: 0,
    //         title: "Бакалавриат / специалитет",
    //         description:
    //           "При подаче заявления о приеме поступающий представляет: документ (документы), удостоверяющий личность, гражданство (в том числе может представить паспорт гражданина Российской Федерации, удостоверяющий личность гражданина Российской Федерации за пределами территории Российской Федерации); документ об образовании и(или) квалификации, на основании которого поступает в образовательную организацию; поступающий может представить один или несколько документов об образовании и(или) квалификации; документ, подтверждающий регистрацию в системе индивидуального (персонифицированного) учета (при наличии); документ, подтверждающий инвалидность или ограниченные возможности здоровья, - при необходимости создания специальных условий для инвалидов и лиц с ограниченными возможностями здоровья; документы, подтверждающие индивидуальные достижения поступающего, результаты которых учитываются при приеме (представляются по усмотрению поступающего); иные документы (представляются по усмотрению поступающего); две фотографии поступающего - для лиц, поступающих на обучение по результатам вступительных испытаний, проводимых организацией самостоятельно (по решению организации). Документ об образовании и(или) квалификации представляется (направляется) поступающим при подаче документов, необходимых для поступления, или в более поздний срок, но не позднее дня завершения приема документов, установленного образовательной организацией."
    //       },
    //     ]
    //   },
    //   {
    //     title: "Магистратура",
    //     path: "/magistratura",
    //     items: [
    //       {
    //         id: 0,
    //         title: "Магистратура",
    //         description:
    //           "Прием на обучение по программам магистратуры проводится по результатам вступительных испытаний, установление перечня и проведение которых осуществляется образовательной или научной организацией самостоятельно. Образовательная или научная организация устанавливает приоритетность вступительных испытаний для ранжирования списков поступающих. Для каждого вступительного испытания устанавливаются: максимальное количество баллов; минимальное количество баллов, подтверждающее успешное прохождения вступительных испытаний."
    //       },
    //     ]
    //   },
    //   {
    //     title: "Аспирантура",
    //     path: "/aspirantura",
    //     items: [
    //       {
    //         id: 0,
    //         title: "Аспирантура",
    //         description:
    //           "Прием на обучение по программам магистратуры проводится по результатам вступительных испытаний, установление перечня и проведение которых осуществляется образовательной или научной организацией самостоятельно. Образовательная или научная организация устанавливает приоритетность вступительных испытаний для ранжирования списков поступающих. Для каждого вступительного испытания устанавливаются: максимальное количество баллов; минимальное количество баллов, подтверждающее успешное прохождения вступительных испытаний."
    //       },
    //     ]
    //   },
    //   {
    //     title: "Ординатура",
    //     path: "/ordinatura",
    //     items: [
    //       {
    //         id: 0,
    //         title: "Ординатура",
    //         description:
    //           "Прием на обучение по программам магистратуры проводится по результатам вступительных испытаний, установление перечня и проведение которых осуществляется образовательной или научной организацией самостоятельно. Образовательная или научная организация устанавливает приоритетность вступительных испытаний для ранжирования списков поступающих. Для каждого вступительного испытания устанавливаются: максимальное количество баллов; минимальное количество баллов, подтверждающее успешное прохождения вступительных испытаний."
    //       },
    //     ]
    //   },
    //   {
    //     title: "Ассистентура-стажировка",
    //     path: "/assistentura",
    //     items: [
    //       {
    //         id: 0,
    //         title: "Ассистентура-стажировка",
    //         description:
    //           "Прием на обучение по программам магистратуры проводится по результатам вступительных испытаний, установление перечня и проведение которых осуществляется образовательной или научной организацией самостоятельно. Образовательная или научная организация устанавливает приоритетность вступительных испытаний для ранжирования списков поступающих. Для каждого вступительного испытания устанавливаются: максимальное количество баллов; минимальное количество баллов, подтверждающее успешное прохождения вступительных испытаний."
    //       },
    //     ]
    //   },
    //   {
    //     title: "Целевое обучение/целевая квота",
    //     path: "/celevoe",
    //     items: [
    //       {
    //         id: 0,
    //         title: "Целевое обучение/целевая квота",
    //         description:
    //           "Прием на обучение по программам магистратуры проводится по результатам вступительных испытаний, установление перечня и проведение которых осуществляется образовательной или научной организацией самостоятельно. Образовательная или научная организация устанавливает приоритетность вступительных испытаний для ранжирования списков поступающих. Для каждого вступительного испытания устанавливаются: максимальное количество баллов; минимальное количество баллов, подтверждающее успешное прохождения вступительных испытаний."
    //       },
    //     ]
    //   },
    //   {
    //     title: "Поступление в общем порядке",
    //     path: "/obshiy",
    //     items: [
    //       {
    //         id: 0,
    //         title: "Поступление в общем порядке",
    //         description:
    //           "Прием на обучение по программам магистратуры проводится по результатам вступительных испытаний, установление перечня и проведение которых осуществляется образовательной или научной организацией самостоятельно. Образовательная или научная организация устанавливает приоритетность вступительных испытаний для ранжирования списков поступающих. Для каждого вступительного испытания устанавливаются: максимальное количество баллов; минимальное количество баллов, подтверждающее успешное прохождения вступительных испытаний."
    //       },
    //     ]
    //   },
    //   {
    //     title: "Поступление по квоте Правительства РФ",
    //     path: "/kvota",
    //     items: [
    //       {
    //         id: 0,
    //         title: "Поступление по квоте Правительства РФ",
    //         description:
    //           "Прием на обучение по программам магистратуры проводится по результатам вступительных испытаний, установление перечня и проведение которых осуществляется образовательной или научной организацией самостоятельно. Образовательная или научная организация устанавливает приоритетность вступительных испытаний для ранжирования списков поступающих. Для каждого вступительного испытания устанавливаются: максимальное количество баллов; минимальное количество баллов, подтверждающее успешное прохождения вступительных испытаний."
    //       },
    //     ]
    //   },
    //   {
    //     title: "Гражданам Республики Белоруссия",
    //     path: "/belarus",
    //     items: [
    //       {
    //         id: 0,
    //         title: "Гражданам Республики Белоруссия",
    //         description:
    //           "Прием на обучение по программам магистратуры проводится по результатам вступительных испытаний, установление перечня и проведение которых осуществляется образовательной или научной организацией самостоятельно. Образовательная или научная организация устанавливает приоритетность вступительных испытаний для ранжирования списков поступающих. Для каждого вступительного испытания устанавливаются: максимальное количество баллов; минимальное количество баллов, подтверждающее успешное прохождения вступительных испытаний."
    //       },
    //     ]
    //   },
    //   {
    //     title: "Признание зарубежного образования",
    //     path: "/priznanie",
    //     items: [
    //       {
    //         id: 0,
    //         title: "Признание зарубежного образования",
    //         description:
    //           "Прием на обучение по программам магистратуры проводится по результатам вступительных испытаний, установление перечня и проведение которых осуществляется образовательной или научной организацией самостоятельно. Образовательная или научная организация устанавливает приоритетность вступительных испытаний для ранжирования списков поступающих. Для каждого вступительного испытания устанавливаются: максимальное количество баллов; минимальное количество баллов, подтверждающее успешное прохождения вступительных испытаний."
    //       },
    //     ]
    //   },
    // ]
  },
  mutations: {
    setToggleNumberBlocks(state, payload) {
      state.toggleNumberBlocks = payload;
      state.toggleNumberBlocksLoaded = true;
    },
    addToggleNumberBlockItem(state, payload) {
      console.log(111, payload);
      console.log(22, state.toggleNumberBlocks)
      state.toggleNumberBlocks.map((block) => {

        if (block.path === payload.currentPath) {
          payload.newObj.id = block.items.length;
          payload.newObj.modals = [];
          block.items.push({ ...payload.newObj });
        }
      });
      //console.log("addToggleNumberBlockItem", state.toggleNumberBlocks);
    },
    deleteToggleNumberBlockItem(state, payload) {
      state.toggleNumberBlocks.map((block) => {
        if (block.path === payload.currentPath) {
          block.items = block.items?.filter((item) => item.id !== payload.id);
          let counter = 0;
          block.items.map((item) => {
            item.id = counter;
            counter++;
          });
        }
      });
      //console.log("deleteToggleNumberBlockItem", state.toggleNumberBlocks);
    },
    moveToggleNumberBlockItemUp(state, payload) {
      if (payload.id <= 0) {
        return;
      } else {
        state.toggleNumberBlocks.map((block) => {
          if (block.path === payload.currentPath) {
            block.items[payload.id - 1].id = payload.id;
            block.items[payload.id].id = payload.id - 1;
            block.items?.splice(
              payload.id - 1,
              2,
              block.items[payload.id],
              block.items[payload.id - 1]
            );
          }
        });
        //console.log("moveToggleNumberBlockItemUp", state.toggleNumberBlocks);
      }
    },
    moveToggleNumberBlockItemDown(state, payload) {
      state.toggleNumberBlocks.map((block) => {
        if (block.path === payload.currentPath) {
          if (payload.id >= block.items.length - 1) {
            return;
          } else {
            block.items[payload.id + 1].id = payload.id;
            block.items[payload.id].id = payload.id + 1;
            block.items?.splice(
              payload.id,
              2,
              block.items[payload.id + 1],
              block.items[payload.id]
            );
          }
        }
      });
      //console.log("moveToggleNumberBlockItemDown", state.toggleNumberBlocks);
    },
    addModalText(state, payload) {
      state.toggleNumberBlocks.map((block) => {
        if (block.path === payload.currentPath) {
          block.items.map(item => {
            if (item.id === payload.parentId) {
              payload.newObj.id = payload.modalId;
              payload.newObj.parentId = payload.parentId;
              item.modals.push({ ...payload.newObj });
            }
          });
        }
      });
      //console.log('addModalText', state.toggleNumberBlocks);
    }
  },
  actions: {
    async downloadToggleNumberBlocks({ commit }) {
      const bakalavriat = await request({
        endpoint: `/api/get?id=bakalavriat`,
        method: "GET"
      });
      const magistratura = await request({
        endpoint: `/api/get?id=magistratura`,
        method: "GET"
      });
      const aspirantura = await request({
        endpoint: `/api/get?id=aspirantura`,
        method: "GET"
      });
      const ordinatura = await request({
        endpoint: `/api/get?id=ordinatura`,
        method: "GET"
      });
      const assistentura = await request({
        endpoint: `/api/get?id=assistentura`,
        method: "GET"
      });
      const celevoe = await request({
        endpoint: `/api/get?id=celevoe`,
        method: "GET"
      });
      const obshiy = await request({
        endpoint: `/api/get?id=obshiy`,
        method: "GET"
      });
      const kvota = await request({
        endpoint: `/api/get?id=kvota`,
        method: "GET"
      });
      const belarus = await request({
        endpoint: `/api/get?id=belarus`,
        method: "GET"
      });
      const priznanie = await request({
        endpoint: `/api/get?id=priznanie`,
        method: "GET"
      });
      const budget = await request({
        endpoint: `/api/get?id=budget`,
        method: "GET"
      });
      const toggleNumberBlocksData = [
        bakalavriat.data,
        magistratura.data,
        aspirantura.data,
        ordinatura.data,
        assistentura.data,
        celevoe.data,
        obshiy.data,
        kvota.data,
        belarus.data,
        priznanie.data,
        budget.data
      ];
      //console.log("SET_APPLICANT_INFOBLOCKS", res.data);
      commit("setToggleNumberBlocks", toggleNumberBlocksData);
    },
    async sendToggleNumberBlocks({ state }, payload) {
      const objToSend = state.toggleNumberBlocks.find(block => block.path === ('/' + payload.path))
      try {
        await axios.post(`/api/set?id=${payload.path}`, JSON.stringify(objToSend), {
          headers: {
            'Content-Type': 'text/plain'
          },
          responseType: 'text'
        })
            .then(() => alert("Данные отправлены"))
            .catch((e) => alert("Ошибка отправки данных " + e))
      }catch (e) {
        alert("Ошибка отправки данных " + e);
      }

    }
  },
  getters: {
    getToggleNumberBlocks(state) {
      return state.toggleNumberBlocks;
    },
    getToggleNumberBlocksLoadingStatus(state) {
      return state.toggleNumberBlocksLoaded;
    }
  }
};